import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGridPro, GridActionsCellItem, koKR } from '@mui/x-data-grid-pro';
import {
  Backdrop,
  Badge,
  Chip,
  CircularProgress,
  Box,
  Button,
  Container,
  CssBaseline,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  styled,
  Tooltip,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import  {
  Attachment,
  Clear,
  Search,
  Delete,
  OpenInNew,
  Send,
  PictureAsPdf,
  Image,
  Download,
  Downloading,
  Launch,
  Visibility,
  ChevronLeft,
  ChevronRight,
} from '@mui/icons-material';
import {
  FormInputAutoComplete,
  FormInputText
} from "../form";
import {
  AlertDialog,
  DialogTitleClose,
  PaperComponent,
  ConfirmDialog,
} from "../dialog";
import { CustomNoRowsOverlay } from "../datagrid";
import { mode } from "../../config";
import { dateFormat } from "../../utils";
import { uploadFilePath, fileServerUrl } from '../../config';
import * as gclientActions from "../../store/gclient";
import * as g04docuFileActions from "../../store/g04docuFile";
import * as gsendG04docuActions from "../../store/gsendG04docu";
import GSendG04docuDialog from "./GSendG04docuDialog";
import { getGridHeight } from "../../constants/gridHeights";
import DocumentViewerDrawer from "../common/viewer/DocumentViewerDrawer";
import MobilePdfPreview from "../common/viewer/MobilePdfPreview";
import SendMailTypeDialog from "../dialog/SendMailTypeDialog";
import { v4 as uuidv4 } from 'uuid';


const GRID_HEIGHT = getGridHeight('ONE_LINE_LAYER', -28); // 0px 추가 여백
const MOBILE_PAGE_SIZE = 10;

const formatSentAt = (value) => {
  if (!value) return '';
  const today = dateFormat(new Date(), 'yyyy-MM-dd');
  const text = dateFormat(value, 'yyyy-MM-dd HH:mm') || '';
  return text.replace(`${today}`, '오늘');
};

const counterpartName = (row, sessionUser) => {
  if (row?.gclientIdFrom && sessionUser?.id && row.gclientIdFrom === sessionUser.id) {
    return row.toGClient || '';
  }
  return row?.fromGClient || row?.toGClient || '';
};

const recipientLabel = (row) => {
  const mailTo = Array.isArray(row?.mailTo) ? row.mailTo : [];
  const names = mailTo.map((mail) => (mail?.name || mail?.id || '').trim()).filter(Boolean);
  if (names.length === 0) return '';
  if (names.length === 1) return names[0];
  return `${names[0]} 외 ${names.length - 1}명`;
};

const mailSubject = (row) => (row?.subject || '').replace(/<[^>]*>/g, '').trim();

const mobileDialogTitleSx = {
  position: 'relative',
  fontSize: '18px !important',
  fontWeight: '600 !important',
  lineHeight: 1.3,
  padding: '16px 56px 16px 16px !important',
  '& .MuiIconButton-root[aria-label="close"]': {
    marginTop: '0 !important',
    top: '50%',
    transform: 'translateY(-50%)',
  },
};

const theme = createTheme();

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 1,
    top: 13,
    // border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    color: "white",
    backgroundColor: "#9e9e9e",
  },
}));

const defaultValues = {
  // gclientId: "",
  // division: '',
  type: '',
  searchWord: "",
  name: "",
  classification: "",
};

const GSendG04docuManagement = ({
  title,
  from,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // const [anchorEl, setAnchorEl] = useState(null);
  const [gclientIdFrom, setGClientIdFrom] = useState("");
  const [gclientIdTo, setGClientIdTo] = useState("");
  const [gclients, setGClients] = useState([]);
  const [crudMode, setCrudMode] = useState('');
  const [open, setOpen] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [errors, setErrors] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [removeId, setRemoveId] = useState();
  const [params, setParams] = useState({});
  const [checked, setChecked] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(0);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [hideGClientNameColumn, setHideGClientNameColumn] = useState(true);
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [alertInfo, setAlertInfo] = useState({});

  const [attachFiles, setAttachFiles ] = useState([]);
  const [documentViewerDrawerOpen, setDocumentViewerDrawerOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [selectedMails, setSelectedMails] = useState([]);

  const [openMailDialog, setOpenMailDialog] = useState(false);

  const options = useSelector((state) => state.dialog.options);
  console.log("options => ", options)
  // const openFunctionMenu = Boolean(anchorEl);
  
  // 기능버튼 메뉴
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  
  const handleSelect = async ({ type, params }) => {
    // setAnchorEl(null);
    console.log("params => ", params)
    
    const { id, row } = params;

    setOpenBackdrop(true);

    if (type === "detail") {
      setSelectedRow(row);
      setCrudMode('R');
      setOpen(true);
    } else if (type === "delete") {
      setRemoveId(id);
      setConfirmOpen(true);
    } else if (type === "sendMail") {
      setSelectedRow(row);
      setOpenMailDialog(true);
    }

    setOpenBackdrop(false);
  }

  const remove = async (removeId) => {
    if (removeId) {
      dispatch(gsendG04docuActions.remove(removeId))
        .then(res => {
          // setSelectionModel([]);
          if (selectedRow && selectedRow.id === removeId) setOpen(false);
          selectGSendG04docus({ gclientIdFrom, gclientIdTo });
        })
        .catch(async (res) => {
          console.log(res)
          const data = await res.json();
          if (data && data.errors) setErrors(data.errors);
        });
    } else {
      // console.log(selectionModel)
      await removeSelectedDirect(selectionModel);
      selectGSendG04docus({ gclientIdFrom, gclientIdTo });
    }
  }

  const handleClickRemoveSelected = async () => {
    setRemoveId("");
    setConfirmOpen(true);
  }

  // const options = [
  //   {
  //     text: '수정',
  //     icon: <Edit fontSize="small" />,
  //     type: 'edit',
  //   },
  //   {
  //     text: '삭제',
  //     icon: <Delete fontSize="small" />,
  //     type: 'delete',
  //   },
  // ];
  const handleChangeOrder = () => {
    setChecked(!checked);
  }

  const generateActions = (params) => {
    let arrActions = [
      <GridActionsCellItem
        icon={<Send />}
        label={"전달"}
        onClick={() => handleSelect({ type: 'sendMail', params })}
        showInMenu
      />,
      <GridActionsCellItem
        icon={<OpenInNew />}
        label={"상세"}
        onClick={() => handleSelect({ type: 'detail', params })}
        showInMenu
      />,
      <GridActionsCellItem
        icon={<Delete />}
        label={"삭제"}
        onClick={() => handleSelect({ type: 'delete', params })}
        showInMenu
      />,
    ];

    return arrActions;
  }

  const handleClickAttachment = (e, attachments) => {
    // console.log(attachments)
    e.stopPropagation();

    setAttachFiles(attachments);

    setTimeout(() => setOpenFile(true), 500);
  }

  const handleFileDialogClose = () => {
    setOpenFile(false);
  }

  const columns = [
    // {
    //   field: 'gclientIdFrom',
    //   headerName: '보낸 거래선 아이디',
    //   width: 200,
    //   // editable: true,
    // },
    {
      field: 'fromGClient',
      headerName: '보낸 거래선',
      width: 150,
      // editable: true,
    },
    // {
    //   field: 'gclientFrom',
    //   headerName: '보낸 거래선',
    //   width: 200,
    //   // editable: true,
    // },
    // {
    //   field: 'gclientIdTo',
    //   headerName: '받은 거래선 아이디',
    //   width: 200,
    //   // editable: true,
    // },
    // {
    //   field: 'gclientTo',
    //   headerName: '받은 거래선',
    //   width: 200,
    //   // editable: true,
    // },
    {
      field: 'toGClient',
      headerName: '받은 거래선',
      width: 150,
      // editable: true,
    },
    {
      field: 'mailFrom',
      headerName: '보낸 사람',
      width: 200,
      // editable: true,
      hide: true,
    },
    {
      field: 'mailTo',
      headerName: '받은 사람',
      width: 340,
      // editable: true,
      // renderCell: (params) => (
      //   <Box>
      //     {params.row.mailTo?.map((to, index) => {
      //       const match = to.id.match(/^<([^>]+)>/);
      //       const tooltipText = match ? match[1] : null;
            
      //       return tooltipText ? (
      //         <Box key={index} sx={{ mb: index < params.row.mailTo.length - 1 ? 0.5 : 0 }}>
      //           <Tooltip title={tooltipText} arrow>
      //             <Chip label={to.name} size="small" sx={{ mr: 1 }} />
      //           </Tooltip>
      //         </Box>
      //       ) : (
      //         <Box key={index} sx={{ mb: index < params.row.mailTo.length - 1 ? 0.5 : 0 }}>
      //           <Chip label={to.name} size="small" sx={{ mr: 1 }} />
      //         </Box>
      //       );
      //     })}
      //   </Box>
      // ),
      renderCell: (params) => {
        const mailList = params.row.mailTo || [];
        
        const handleOpenDialog = (e, mails) => {
          e.stopPropagation();
          setSelectedMails(mails);
          setOpenEmailDialog(true);
        };
    
        return (
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            width: '100%',
            overflow: 'hidden'
          }}>
            {mailList.length > 0 && (
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                width: '100%'
              }}>
                {/* 첫 번째 메일 Chip으로 표시 */}
                {(() => {
                  const to = mailList[0];
                  const match = to.id.match(/^<([^>]+)>/);
                  const tooltipText = match ? match[1] : null;
                  
                  return tooltipText ? (
                    <Tooltip title={tooltipText} arrow>
                      <Chip 
                        label={to.name} 
                        size="small"
                      />
                    </Tooltip>
                  ) : (
                    <Chip 
                      label={to.name} 
                      size="small"
                    />
                  );
                })()}
    
                {/* 2개 이상일 경우 "외 N건" + 아이콘 표시 */}
                {mailList.length > 1 && (
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    ml: 1,
                    whiteSpace: 'nowrap'
                  }}>
                    <Typography variant="body2" sx={{ mr: 0.5 }}>
                      외 {mailList.length - 1}명
                    </Typography>
                    <IconButton 
                      size="small"
                      onClick={(e) => handleOpenDialog(e, mailList)}
                    >
                      <Launch fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        );
      }
    },
    {
      field: 'mailCc',
      headerName: '참조',
      width: 200,
      // editable: true,
      hide: true,
      renderCell: (params) => (params.row.mailCc?.map(cc => (<Chip label={cc.name} size="small" sx={{ mr: 1 }}></Chip>))),
    },
    {
      field: 'mailCcInternal',
      headerName: '내부참조',
      width: 200,
      // editable: true,
      hide: true,
      renderCell: (params) => (params.row.mailCcInternal?.map(ccInternal => (<Chip label={ccInternal.name} size="small" sx={{ mr: 1 }}></Chip>))),
    },
    {
      field: 'subject',
      headerName: '제목',
      width: 270,
      // editable: true,
      renderCell: (params) => {
        return (
          <Tooltip title={params.value}>
            <Box sx={{
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {params.value}
            </Box>
          </Tooltip>
        )
      },
    },
    {
      field: 'html',
      headerName: '메시지',
      width: 270,
      // editable: true,
      hide: false,
      renderCell: (params) => {
        return (
          <Tooltip title={<span dangerouslySetInnerHTML={{ __html: params.value }} />} arrow>
            <Box
              component="div"
              dangerouslySetInnerHTML={{ __html: params.value }}
              sx={{
                whiteSpace: 'normal', // 줄바꿈 허용
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 1, // 원하는 줄 수로 설정
                WebkitBoxOrient: 'vertical',
              }}
            />
          </Tooltip>
        )
      },
    },
    {
      field: 'attachments',
      headerName: '첨부파일',
      width: 90,
      // editable: true,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const { attachments } = params.row;
        if (attachments && Array.isArray(attachments) && attachments.length > 0) {
          return (
            <Tooltip title={"첨부파일 보기"}>
              <IconButton onClick={(e) => handleClickAttachment(e, attachments)}>
                <Attachment />
              </IconButton>
            </Tooltip>
          )
        }
      }
    },
    {
      field: 'sendMailResults',
      headerName: '전송 메일 결과',
      width: 200,
      // editable: true,
      hide: true,
      renderCell: (params) => {
        if (mode.indexOf('java') > 0) {
          console.log(params)
          const { sendMailResults } = params.row;
          if (sendMailResults && sendMailResults.result === 'OK') {
            return "전송";
          } else if(sendMailResults && sendMailResults.accepted && Array.isArray(sendMailResults.accepted) && sendMailResults.accepted.length > 0) {
            return "전송";
          } else {
            return "미전송";
          }
        } else {
          return (
            <>
              <StyledBadge
                badgeContent={params.row.sendMailResults?.accepted.length ? params.row.sendMailResults?.accepted.length : "0"} // 숫자형태의 0이면 나타나지 않음 
                sx={{ mr: 2 }}
              >
                <Chip label={`전송`} />
              </StyledBadge>
              <StyledBadge
                badgeContent={params.row.sendMailResults?.rejected.length ? params.row.sendMailResults?.rejected.length : "0"} // 숫자형태의 0이면 나타나지 않음
              >
                <Chip label={`미전송`} />
              </StyledBadge>
            </>
          )
        }
      },
    },
    {
      field: 'results',
      headerName: '결과',
      width: 200,
      hide: true,
      // editable: true,
    },
    {
      field: 'createdAt',
      headerName: '보낸시간',
      width: 160,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        const today = dateFormat(new Date(), 'yyyy-MM-dd');
        const value = dateFormat(params.value, 'yyyy-MM-dd HH:mm');
        return value.replace(`${today}`, "오늘");
      },
    },
    // {
    //   field: 'createdAt',
    //   headerName: '생성일시',
    //   width: 160,
    //   headerAlign: 'center',
    //   align: 'center',
    //   valueGetter: (params) => dateFormat(params.value),
    // },
    // {
    //   field: 'updatedAt',
    //   headerName: '수정일시',
    //   width: 160,
    //   headerAlign: 'center',
    //   align: 'center',
    //   valueGetter: (params) => dateFormat(params.value),
    // },
    {
      field: 'actions',
      headerName: <Tooltip title={"상세"} followCursor><Box>{"기능"}</Box></Tooltip>,
      width: 70,
      type: 'actions',
      getActions: (params) => generateActions(params),
    },
  ];

  const { handleSubmit, control, setValue, getValues } = useForm({ defaultValues: defaultValues });

  const sessionUser = useSelector(state => state.session.sessionUser);
  const rowsGSendG04docu = useSelector((state) => state.gsendG04docu.gsendG04docus);
  const rowCount = useSelector((state) => state.gsendG04docu.count);
  // MUI 서버페이징: 로딩 중 count가 일시적으로 비어도 직전 총건수를 유지
  const [rowCountState, setRowCountState] = useState(0);

  useEffect(() => {
    setRowCountState((prev) => (typeof rowCount === 'number' && rowCount >= 0 ? rowCount : prev));
  }, [rowCount]);
  
  // 데이터 관리
  const dispatch = useDispatch();
  
  const selectAllByQuery = ({ gclientIdFrom, gclientIdTo, searchWord, page, pageSize }) =>
    dispatch(gsendG04docuActions.selectAllByQuery({ gclientIdFrom, gclientIdTo, searchWord, page, pageSize }))
  const removeSelectedDirect = (ids) => gsendG04docuActions.removeSelectedDirect(ids)
  const selectAllGClientDirect = () => gclientActions.selectValidAllDirect()
  const downloadG04docuFile = (documentPath) => g04docuFileActions.downloadDirect(documentPath)

  const queryPaging = useMemo(
    () => ({
      page,
      pageSize,
    }), [page, pageSize]
  );

  useEffect(() => {
    setPage(0);
    setPageSize(isMobile ? MOBILE_PAGE_SIZE : 20);
  }, [isMobile]);

  useEffect(
    () => {
      let cancelled = false;
      (async () => {
        const resGClients = await selectAllGClientDirect();
        if (!cancelled) {
          setGClients(resGClients);
          const { type } = sessionUser;
          if (type === 'ADMIN') {
            setHideGClientNameColumn(false);
          }
          setTimeout(() => setLoaded(true), 300);
        }
      })();
      return () => { cancelled = true; };
    }, [dispatch]
  );

  useEffect(
    () => {
      selectGSendG04docus({
        gclientIdFrom,
        gclientIdTo,
        page: queryPaging.page,
        pageSize: queryPaging.pageSize,
      });
    }, [queryPaging]
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  }

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  }

  const selectGSendG04docus = async ({
    gclientIdFrom,
    gclientIdTo,
    searchWord,
    page: pageParam,
    pageSize: pageSizeParam,
  }) => {
    const paramGClientIdFrom = sessionUser.type === 'ADMIN' ? gclientIdFrom : sessionUser.id; // sessionUser.id로 검색한다는 것은 회원사 사용자별로 검색하는 것이 아니라 회원사 전체로 검색한다는 의미임
    const paramGClientIdTo = gclientIdTo;
    const paramSearchWord = searchWord !== undefined ? searchWord : getValues("searchWord");
    const paramPage = pageParam !== undefined ? pageParam : page;
    const paramPageSize = pageSizeParam !== undefined ? pageSizeParam : pageSize;

    setLoaded(false);
    await selectAllByQuery({
      gclientIdFrom: paramGClientIdFrom,
      gclientIdTo: paramGClientIdTo,
      searchWord: paramSearchWord,
      page: paramPage,
      pageSize: paramPageSize,
    });
    setLoaded(true);
  }

  const resetPageAndSearch = ({ gclientIdFrom, gclientIdTo, searchWord }) => {
    if (page !== 0) {
      setPage(0);
    } else {
      selectGSendG04docus({
        gclientIdFrom,
        gclientIdTo,
        searchWord,
        page: 0,
        pageSize,
      });
    }
  }

  // 거래선명으로 검색
  const handleChangeGClientFrom = (e, value) => {
    const { id: gclientIdFrom } = value;
    setGClientIdFrom(gclientIdFrom);
    resetPageAndSearch({ gclientIdFrom, gclientIdTo });
  }

  const handleChangeGClientTo = (e, value) => {
    const { id: gclientIdTo } = value;
    setGClientIdTo(gclientIdTo);
    resetPageAndSearch({ gclientIdFrom, gclientIdTo });
  }
  
  var timer;
  // 원부자재 및 공정의 이름으로 검색
  const handleChangeSearchWord = async (e) => {
    // 과도한 API 호출 방지를 위한 debouncing 코드. TODO : 라이브러리 활용 검토
    if (timer) {
      clearTimeout(timer);
    }
    // 타이머 설정
    timer = setTimeout(() => {
      const searchWord = e.target.value;
      resetPageAndSearch({ gclientIdFrom, gclientIdTo, searchWord });
    }, 500);
  };

  // 검색버튼
  const handleClickSearch = async () => {
    resetPageAndSearch({ gclientIdFrom, gclientIdTo });
  };

  // const handleClickDownloadAttachFile = async (e, documentPath) => {
  //   e.stopPropagation();

  //   const arr = documentPath.split("/");
  //   const fileName = arr[arr.length - 1];

  //   const res = await downloadG04docuFile(documentPath);
  //   const blob = await res.blob(); // res.blob는 promise를 리턴함???
    
  //   // 2. Create blob link to download
  //   const url = window.URL.createObjectURL(new Blob([blob]));
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', fileName);
  //   // 3. Append to html page
  //   document.body.appendChild(link);
  //   // 4. Force download
  //   link.click();
  //   // 5. Clean up and remove the link
  //   link.parentNode.removeChild(link);
  // }
  const handleClickDownloadAttachFile = async (e, documentPath, idx) => {
    e.stopPropagation();
    
    const newAttachFiles = attachFiles.map((file, i) => (i === idx ? { ...file, downloading: true } : file));

    setAttachFiles(newAttachFiles);
    const arr = documentPath.split("/");
    const fileName = arr[arr.length - 1];

    const res = await downloadG04docuFile(documentPath);
    const blob = await res.blob(); // res.blob는 promise를 리턴함???
    
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);
    
    setTimeout(() => {
      setAttachFiles(newAttachFiles.map((file, i) => (i === idx ? { ...file, downloading: false } : file)));
    }, 1000);
  }

  const handleClickViewEachDoc = (documentPath) => {
    const pathParts = documentPath.replace(/\\/g, '/').replace(uploadFilePath, '').split('/');
    
    // 캐싱으로 인해 이전 문서가 계속 보이는 문제 해결
    const randNumber = Math.floor(Math.random()*99);
    
    // 경로를 '/'로 분리하고 각 부분을 개별적으로 인코딩
    const encodedPath = pathParts.map(part => encodeURIComponent(part)).join('/');

    const path = `${fileServerUrl}${encodedPath}?q=cat&${randNumber}`;
    const rawName = pathParts[pathParts.length - 1] || '문서';
    let previewName = rawName;
    try {
      previewName = decodeURIComponent(rawName);
    } catch (e) {
      previewName = rawName;
    }

    // window.open(`${path}?q=cat&${randNumber}`, "미리보기", 'target="_self"');
    setPreviewTitle(previewName);
    setCurrentUrl(path);
    // Drawer가 닫혀있을 때만 열기
    if (!documentViewerDrawerOpen) {
      setDocumentViewerDrawerOpen(true);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <Container component="main" maxWidth="lg"> */}
      <Container component="main" maxWidth="false">
        <CssBaseline />
        <GSendG04docuDialog
          open={open}
          setOpen={setOpen}
          crudMode={crudMode}
          setCrudMode={setCrudMode}
          selectedRow={selectedRow}
          handleClickDownloadAttachFile={handleClickDownloadAttachFile}
          fullScreen={isMobile}
          onViewDocument={handleClickViewEachDoc}
          onOpenMail={() => setOpenMailDialog(true)}
          onDelete={() => {
            if (!selectedRow?.id) return;
            setRemoveId(selectedRow.id);
            setConfirmOpen(true);
          }}
        />
        <Box sx={isMobile ? {
          mt: 3,
          height: 'calc(100vh - 219px)',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          boxSizing: 'border-box',
        } : { mt: 3 }}>
          <Grid container spacing={2} sx={isMobile ? { flexShrink: 0 } : undefined}>
            {
              title && (
                <Grid item xs={12}>
                  <Typography variant="h5">
                    {title}
                  </Typography>
                </Grid>
              )
            }
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={10}>
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} sx={{ width: '100%' }}>
                    {
                      sessionUser.type === 'ADMIN' && (
                        <FormInputAutoComplete
                          control={control}
                          label={"보낸 거래선"}
                          options={[{ label: "전체", id: "NONE" }].concat(gclients.map(gclient => ({ label: gclient.name, id: gclient.id })))}
                          setValue={setValue}
                          onCustomChange={handleChangeGClientFrom}
                        />
                      )
                    }
                    {/* <FormInputAutoComplete
                      control={control}
                      label={"받은 거래선"}
                      options={[{ label: "전체", id: "NONE" }].concat(gclients.map(gclient => ({ label: gclient.name, id: gclient.id })))}
                      setValue={setValue}
                      onCustomChange={handleChangeGClientTo}
                    /> */}
                    <FormInputText
                      name={"searchWord"}
                      control={control}
                      label={"받은 거래선/제목/메시지로 검색하세요."}
                      onCustomChange={handleChangeSearchWord}
                      sx={{
                        '& .MuiInputBase-root': {
                          background: "#E3EEFA"
                        },
                        '& .MuiFormLabel-root' : {
                          color: '#2196f3',
                        },
                        input: { color: '#2196f3' },
                        mr: { xs: 0, md: 1 },
                        width: { xs: '100%', md: sessionUser.type === 'ADMIN' ? '100%' : '50%' }
                      }}
                      // disabled={gclientIdFrom ? false : true} // TODO : 우신복층유리 1차 오픈
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12} md={2} display="flex" justifyContent={{ xs: 'stretch', md: 'flex-end' }}>
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} sx={{ width: { xs: '100%', md: 'auto' } }}>
                    <Button
                      variant="contained"
                      startIcon={<Search />}
                      onClick={handleClickSearch}
                      sx={{ mr: { xs: 0, md: 1 }, width: { xs: '100%', md: 'auto' } }}
                    >
                      {"검색"}
                    </Button>
                    {!isMobile && (
                      <Button
                        variant="contained"
                        startIcon={<Delete />}
                        onClick={handleClickRemoveSelected}
                        disabled={selectedRows.length > 0 ? false : true}
                        sx={{ width: { xs: '100%', md: 'auto' } }}
                      >
                        {"삭제"}
                      </Button>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {isMobile ? (
            <Box sx={{
              flex: 1,
              minHeight: 0,
              width: '100%',
              mt: 1,
              display: 'flex',
              flexDirection: 'column',
              bgcolor: 'grey.100',
              borderRadius: 1,
              overflow: 'hidden',
            }}>
              {!loaded && <LinearProgress />}
              {loaded && rowsGSendG04docu.length === 0 && (
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography variant="body2" color="text.secondary">
                    전송 이력이 없습니다.
                  </Typography>
                </Box>
              )}
              {rowsGSendG04docu.length > 0 && (
                <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', px: 1, pt: 1, pb: 1 }}>
                  {rowsGSendG04docu.map((row) => {
                    const company = (counterpartName(row, sessionUser) || '').trim();
                    const recipient = recipientLabel(row);
                    const subject = mailSubject(row);
                    const fileCount = Array.isArray(row.attachments) ? row.attachments.length : 0;
                    return (
                      <Paper
                        key={row.id}
                        elevation={0}
                        role="button"
                        onClick={() => handleSelect({ type: 'detail', params: { id: row.id, row } })}
                        sx={{
                          mb: 1,
                          overflow: 'hidden',
                          bgcolor: 'background.paper',
                          borderRadius: 2,
                          cursor: 'pointer',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
                        }}
                      >
                        <Box sx={{ p: 1.25 }}>
                          <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-all' }}>
                            <Box component="span" sx={{ mr: 0.75, color: 'text.secondary', fontWeight: 400 }}>거래선명</Box>
                            {company || '없음'}
                          </Typography>
                          <Typography variant="caption" component="div" sx={{ mt: 0.5, wordBreak: 'break-all' }}>
                            <Box component="span" sx={{ mr: 0.75, color: 'text.secondary' }}>받은 사람</Box>
                            {recipient || '없음'}
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 0.25, wordBreak: 'break-all' }}>
                            <Box component="span" sx={{ mr: 0.75, color: 'text.secondary', fontWeight: 400 }}>제목</Box>
                            {subject || '없음'}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mt: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">
                              {formatSentAt(row.createdAt)}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                              {`첨부문서 ${fileCount}`}
                            </Typography>
                          </Box>
                        </Box>
                      </Paper>
                    );
                  })}
                </Box>
              )}
              <Box
                sx={{
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  minHeight: 44,
                  borderTop: 1,
                  borderColor: 'divider',
                  bgcolor: 'background.paper',
                }}
              >
                <IconButton
                  aria-label="이전 페이지"
                  disabled={!loaded || page <= 0}
                  onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                >
                  <ChevronLeft />
                </IconButton>
                <Typography variant="body2" color="text.secondary">
                  {rowCountState === 0
                    ? '0건'
                    : `${page * pageSize + 1}–${Math.min(rowCountState, (page + 1) * pageSize)} / ${rowCountState}건`}
                </Typography>
                <IconButton
                  aria-label="다음 페이지"
                  disabled={!loaded || (page + 1) * pageSize >= rowCountState}
                  onClick={() => setPage((prev) => prev + 1)}
                >
                  <ChevronRight />
                </IconButton>
              </Box>
            </Box>
          ) : (
          <div style={{ height: from?.params ? 500 : GRID_HEIGHT.REDUCED, width: '100%' }}>
            <DataGridPro
              localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
              sx={{ 
                cursor: 'pointer', 
                mt: 2, 
                fontSize: '0.85em',
                // '& .MuiDataGrid-cell[data-field="mailTo"]': {  // mailTo 필드의 셀만 적용
                //   whiteSpace: 'normal',
                //   padding: '8px',
                //   alignItems: 'flex-start',  // 위쪽 정렬
                //   overflow: 'auto',  // 내용이 많을 때 스크롤
                // },
                '& .MuiDataGrid-cell': {  // 모든 셀에 적용
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                },
                '& .MuiDataGrid-row': {   
                  height: '34px !important', // 모든 행의 높이를 34px로 고정
                }
              }}
              initialState={{ pinnedColumns: { /*left: ['id', 'name', 'code'], */right: ['actions'] } }}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
                loadingOverlay: LinearProgress,
              }}
              headerHeight={38}
              //rowHeight={34}
              // getRowHeight={(params) => {
              //   // mailTo 필드에 데이터가 있고 여러 개인 경우에만 자동 높이 적용
              //   const mailTo = params.model.mailTo;
              //   if (mailTo && Array.isArray(mailTo) && mailTo.length > 1) {
              //     return 'auto';
              //   }
              //   return 34; // 기본 높이
              // }}
              getRowHeight={() => 34} // 모든 행의 높이를 34px로 고정
              loading={!loaded}
              rows={rowsGSendG04docu}
              columns={columns}
              // pageSize={5}
              // rowsPerPageOptions={[5]}
              pageSize={pageSize}
              onPageSizeChange={handlePageSizeChange}
              rowsPerPageOptions={[1, 10, 20, 50, 100]}
              onPageChange={handlePageChange}
              page={page}
              rowCount={rowCountState}
              pagination
              paginationMode="server"
              onRowDoubleClick={(params) => handleSelect({ type: 'detail', params })}
              checkboxSelection
              // checkboxSelection
              // disableSelectionOnClick
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                // console.log(selectedIDs)
                const selected = rowsGSendG04docu.filter((row) =>
                  selectedIDs.has(row.id),
                );
      
                setSelectionModel(ids);

                console.log(selected)
                setSelectedRows(selected);
              }}
              selectionModel={selectionModel}
            />
          </div>
          )}
        </Box>
        <ConfirmDialog
          removeId={removeId}
          title={"삭제"}
          open={confirmOpen}
          setOpen={setConfirmOpen}
          onConfirm={remove}
          onCancel={() => {}}
        >
          {"선택하신 메일을 삭제하시겠습니까?"}
        </ConfirmDialog>
        <AlertDialog
          alertInfo={alertInfo}
          setAlertInfo={setAlertInfo}
        />
      </Container>
      <Dialog
        open={openFile}
        onClose={handleFileDialogClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        // onConfirm={sendOrder}
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleFileDialogClose}
          style={{ cursor: 'move' }}
        >
          {"첨부파일"}
        </DialogTitleClose>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <List>
                {
                  attachFiles.map((file, idx) => {
                    const { filename, path } = file;
                    const pos = filename.lastIndexOf(".");
                    let ext = "";
                    if (pos > -1) {
                      ext = filename.substring(pos+1);
                    }

                    return (
                      <ListItem disablePadding>
                        <ListItemButton>
                          <ListItemIcon>
                            { ext.toLowerCase() === 'pdf' ? <PictureAsPdf /> : <Image /> }
                          </ListItemIcon>
                          <ListItemText primary={filename} />
                          <IconButton onClick={(e) => handleClickDownloadAttachFile(e, path, idx)}>
                            { file.downloading ? <Downloading /> : <Download /> }
                          </IconButton>
                          <IconButton onClick={(e) => handleClickViewEachDoc(path)}>
                            <Visibility />
                          </IconButton>
                        </ListItemButton>
                      </ListItem>
                    )
                  })
                }
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFileDialogClose}>{"닫기"}</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openEmailDialog}
        onClose={() => setOpenEmailDialog(false)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={() => setOpenEmailDialog(false)}
          style={{ cursor: 'move' }}
        >
          {"받은 사람 목록"}
        </DialogTitleClose>
        <DialogContent>
          <List>
            {selectedMails.map((mail, index) => {
              const match = mail.id.match(/^<([^>]+)>/);
              const company = match ? match[1] : null;
              
              return (
                <ListItem key={index} sx={{ p: 0.5 }}>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={12} sm={company ? 8 : 12}>
                      <Chip 
                        label={mail.name} 
                        size="small" 
                        sx={{ maxWidth: '100%', padding: '0.5em 0.5em', fontSize: '1em' }}
                      />
                    </Grid>
                    {company && (
                      <Grid item xs={12} sm={4}>
                        <Typography variant="subtitle2" color="primary" sx={{ fontSize: '1em' }}>
                          {company}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
      </Dialog>
      {isMobile ? (
        <Dialog
          open={documentViewerDrawerOpen}
          onClose={() => setDocumentViewerDrawerOpen(false)}
          fullScreen
          PaperProps={{ sx: { display: 'flex', flexDirection: 'column' } }}
        >
          <DialogTitleClose
            onClose={() => setDocumentViewerDrawerOpen(false)}
            sx={mobileDialogTitleSx}
          >
            <Box
              component="span"
              title={previewTitle || undefined}
              sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {previewTitle || '문서'}
            </Box>
          </DialogTitleClose>
          <DialogContent sx={{ p: '0 !important', flex: 1, minHeight: 0, display: 'flex', overflow: 'hidden' }}>
            {currentUrl && (
              <MobilePdfPreview src={currentUrl} title={previewTitle || '문서'} />
            )}
          </DialogContent>
        </Dialog>
      ) : (
      <DocumentViewerDrawer
        open={documentViewerDrawerOpen}
        onClose={() => setDocumentViewerDrawerOpen(false)}
        url={currentUrl}
        anchor="left"
      />
      )}
      <SendMailTypeDialog
          open={openMailDialog}
          onClose={() => setOpenMailDialog(false)}
          mailType = "RELAY"
          selectedRow={selectedRow}
          handleClickDownloadAttachFile={handleClickDownloadAttachFile}
          fullScreen={isMobile}
        />
    </ThemeProvider>
  );
};


export default GSendG04docuManagement;
